/* eslint-disable camelcase, @typescript-eslint/naming-convention */
// Client telemetry (ipa-training-mode).
// Fire-and-forget POST through the same orchestratorApiClient every other
// widget→backend write already uses (see submitFeedback/submitUndo in
// chatApi.ts) — no new client subsystem. Never blocks or throws: a failed
// telemetry POST must never affect the coaching/chip/nudge UX.
import orchestratorApiClient from './orchestrator-api-client';
import { TELEMETRY_EVENTS_PATH } from '../constants/telemetry';
export function trackEvent(event, options) {
    var _a;
    const payload = {
        event,
        conversation_id: (_a = options === null || options === void 0 ? void 0 : options.conversation_id) !== null && _a !== void 0 ? _a : null,
        metadata: options === null || options === void 0 ? void 0 : options.metadata
    };
    void orchestratorApiClient.post(TELEMETRY_EVENTS_PATH, payload).catch((err) => {
        if (process.env.NODE_ENV !== 'production') {
            console.warn('[AIChatWidget] Telemetry event failed to send:', err);
        }
    });
}
